import React from 'react'

import { getFieldInPx } from '../_helpers/fieldInPixels'
import { usePdfOptionsForm } from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Qrcode from '../../../../containers/qrcodes/Qrcode'
import View from '../../../../components/pdf/View'

const QrcodeWithTemplate = ({ qrcode }) => {
  const form = usePdfOptionsForm()

  const defaultCSS = {
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "SF Pro Display", "Nunito", "Montserrat", sans-serif',
    lineHeight: '110%',
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
  }

  return (
    <View noWrap style={{ padding: form.qrcodePadding + 'cm', display: 'inline-block' }}>
      <Qrcode qrcode={qrcode} size={getFieldInPx(form, 'qrcodeSize')} />
      {form.activationDetails && qrcode?.data?.name && (
        <div
          style={{
            ...defaultCSS,
            fontSize: getFieldInPx(form, 'qrcodeSize') / 19,
            width: getFieldInPx(form, 'qrcodeSize')
          }}
        >
          {qrcode?.data?.name?.toUpperCase()}
        </div>
      )}
    </View>
  )
}

export default QrcodeWithTemplate
